
import api from './Api'

export default {
  // CRUD operations para equipamientos principales
  getEquipment: (params) => api().get('/equipment-assignment', { params }),
  view: (id) => api().get(`/equipment-assignment/${id}`),
  
  // Crear equipamiento y asignar tipos de vehículos
  post: (payload) => {
    // Si incluye vehicle_types, usar el endpoint de creación completa
    if (payload.vehicle_types && payload.vehicle_types.length > 0) {
      return api().post('/equipment-crud', {
        name: payload.name
      }).then(response => {
        // Después de crear, asignar tipos de vehículos
        if (response.data.success && response.data.data.id) {
          return api().post('/equipment-assignment/bulk-assign', {
            equipment_id: response.data.data.id,
            vehicle_types: payload.vehicle_types
          }).then(() => {
            // Devolver el equipamiento con las asignaciones
            return api().get(`/equipment-assignment/${response.data.data.id}`)
          })
        }
        return response
      })
    }
    // Solo crear equipamiento sin asignaciones
    return api().post('/equipment-crud', payload)
  },
  
  // Actualizar equipamiento y sincronizar tipos de vehículos
  put: (payload) => {
    const equipmentUpdate = api().put(`/equipment-crud/${payload.id}`, {
      name: payload.name
    })
    
    // Si incluye vehicle_types, sincronizar asignaciones
    if (payload.vehicle_types !== undefined) {
      return equipmentUpdate.then(response => {
        return api().put(`/equipment-assignment/sync/${payload.id}`, {
          vehicle_types: payload.vehicle_types
        }).then(() => {
          // Devolver los datos actualizados
          return api().get(`/equipment-assignment/${payload.id}`)
        })
      })
    }
    
    return equipmentUpdate
  },
  
  delete: (payload) => api().delete(`/equipment-crud/${payload.id}`),

  // Asignaciones específicas
  assignVehicleTypes: (equipmentId, vehicleTypes) => 
    api().post('/equipment-assignment/bulk-assign', {
      equipment_id: equipmentId,
      vehicle_types: vehicleTypes
    }),
    
  syncVehicleTypes: (equipmentId, vehicleTypes) => 
    api().put(`/equipment-assignment/sync/${equipmentId}`, {
      vehicle_types: vehicleTypes
    }),

  // Obtener toda la configuración relacional para el dealer autenticado
  getAllConfig: () => api().get('/equipment/config-relacional-todo'),

  // Guardar configuración relacional
  saveConfig: (payload) => api().post('/equipment/save-config-relacional', payload),

  // Consultar configuración para una combinación específica
  getConfigByCombination: (vehicleCondition, receptionStage, vehicleType) =>
    api().get('/equipment/config-relacional', {
      params: { condition: vehicleCondition, stage: receptionStage, type: vehicleType }
    }),
  getConfigByCombinationMovements: (dealerId, vehicleCondition, receptionStage, vehicleType) =>
    api().get('/equipment/config-relacional-movements', {
      params: { dealer_id: dealerId, condition: vehicleCondition, stage: receptionStage, type: vehicleType }
    }),

  // Catálogos
  getVehicleConditions: () => api().get('/catalog/vehicle-condition'),
  getReceptionStages: () => api().get('/catalog/reception-stage'),
  getVehicleTypes: () => api().get('/catalog/vehicle-type'),
  getEquipments: () => api().get('/catalog/equipment'),
  
  // Consulta simple de equipamientos por tipo (para frontend)
  getEquipmentByVehicleType: (vehicleType) => 
    api().get('/simple-equipment/get-equipment', { params: { vehicleType } }),
    
  getAllVehicleTypes: () => 
    api().get('/simple-equipment/get-all-types')
}
